import { useState, useEffect } from 'react';
import {
    InputLabel, FormControl, MenuItem, Select, Card, Table, Grid, TextField, Button, TableBody, TableCell, Container, TableContainer, TablePagination, Modal, Box, TableRow, Typography, Divider,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Page from './../../components/Page';
import Scrollbar from './../../components/Scrollbar';
import { UserListHead } from '../../sections/@dashboard/user';
import HeaderBreadcrumbs from './../../components/HeaderBreadcrumbs';
import { BorderColorOutlined } from "@mui/icons-material";
import "./../TeamManager/TeamManager.css"
import { toast } from 'react-toastify';
import { GetSeriesManagerList, ResetGetSeriesManagerList, UpdateSeriesManager } from 'src/redux/actions/SeriesManagerAction';
import Loader from 'src/components/Loader';

export default function SeriesFootballManager() {
    const dispatch = useDispatch();
    const teamManagerData = useSelector(state => state.series_manager.series_manager_list.data)
    const filterManagerListData = useSelector(state => state.series_manager.series_manager_filter_list.data)
    const loadingSelector = useSelector(state => state.series_manager.loading)
    const updateSelector = useSelector(state => state.series_manager.series_manager_edit)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [showeditModal, setShoweditModal] = useState(false)
    const [uploadedImage, setUploadedImage] = useState(null)
    const [teamShortName, setTeamShortName] = useState()
    const [teamModalData, setTeamModalData] = useState()
    const [selectTeamName, setSelectTeamName] = useState('');

    useEffect(() => {
        dispatch(GetSeriesManagerList((page + 1), rowsPerPage, "fb", {}))
        return () => dispatch(ResetGetSeriesManagerList())
    }, [dispatch, page, rowsPerPage])

    const handleResetFilter = () => {
        dispatch(GetSeriesManagerList((page + 1), rowsPerPage, "fb", {}))
        setSelectTeamName("")
    }

    useEffect(() => {
        if (Object.keys(updateSelector).length > 0) {
            if (updateSelector.status) {
                toast.success(updateSelector.data.message, { theme: "colored" })
                setShoweditModal(false)
                setTimeout(() => {
                    dispatch(GetSeriesManagerList((page + 1), rowsPerPage, "fb", {}))
                }, 800);
            }
        }
    }, [updateSelector])

    const handleEditCloseModal = () => {
        setShoweditModal(false)
        setTeamModalData("")
    }

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleEdit = (data) => {
        setShoweditModal(true)
        setTeamModalData(data)
    }

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "30%",
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4,
    };

    const handleChange = (e) => {
        const { files } = e.target
        if (files?.length > 0) {
            const { name, type } = files[0];
            const params = {
                key: name.includes('.') ? name.substring(0, name.indexOf('.')) : name,
                extension: type.includes('/') ? type.substring(type.indexOf('/') + 1) : type
            };

            if (
                params.extension.toLowerCase() === "jpg" ||
                params.extension.toLowerCase() === "jpeg" ||
                params.extension.toLowerCase() === "png"
            ) {
                if (files) {
                    const reader = new FileReader();
                    reader.onload = function (e) {
                        document.getElementById('profileImg').src = e.target.result;
                    };
                    reader.readAsDataURL(e.target.files[0]);
                    setUploadedImage(e.target.files[0])
                }
                toast.success('Image Uploaded Successfully', { theme: "colored" });
            } else {
                toast.error("Only image with .jpeg, .jpg, .png extentions are valid.");
            }
        }
    }

    const handlestateFilterHandler = (key) => {
        if (key) {
            dispatch(GetSeriesManagerList((page + 1), rowsPerPage, "fb", { name: key }))
            setSelectTeamName(key)
        }
    };

    const handleEditSubmit = (e) => {
        e.preventDefault();
        let formData = new FormData();
        formData.append("league_id", teamModalData.season_id);
        formData.append("type", "Football");
        if (teamShortName) {
            formData.append("short_name", teamShortName);
        }
        if (uploadedImage) {
            formData.append("logo_url", uploadedImage);
        }
        dispatch(UpdateSeriesManager(formData))
        handleResetFilter()
    }

    return (
        <Page title="Football Series Manager">
            {loadingSelector ? <Loader /> : null}

            <Modal
                open={showeditModal}
                onClose={handleEditCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography
                        id="modal-modal-title"
                        style={{ marginBottom: 20 }}
                        align={"center"}
                        variant="h6"
                        component="h2"
                    >
                        Edit
                    </Typography>
                    <Divider />
                    <br />
                    <form autoComplete="off" onSubmit={handleEditSubmit}>
                        <Grid container spacing={2}>
                            <Grid xs={12}>
                                <TextField
                                    required
                                    type="text"
                                    onChange={(e) => setTeamShortName(e.target.value)}
                                    defaultValue={teamModalData?.short_code}
                                    style={{ marginTop: 30, width: "100%" }}
                                    label="Team Short Name*"
                                    variant="outlined"
                                    inputProps={{ maxLength: 10 }}
                                />
                            </Grid>
                            <Grid xs={12} style={{ marginTop: 30, marginBottom: 20 }}>
                                <input
                                    
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => handleChange(e)}
                                    style={{ width: "100%", fontSize: 16 }}
                                />
                                {uploadedImage ?
                                    <img src="" id="profileImg" className="img-fluid" height="70" style={{ marginTop: 10 }} alt="" />
                                    : null
                                }
                                {teamModalData && !uploadedImage ?
                                    <img src={teamModalData.logo_path} className="img-fluid" height="70" style={{ marginTop: 10 }} alt="" />
                                    : null
                                }
                            </Grid>
                            <Grid xs={12}>
                                <Button
                                    align={"center"}
                                    style={{ marginTop: 20, width: "100%" }}
                                    variant="contained"
                                    fullWidth
                                    size="large"
                                    type='submit'
                                >
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </Box>
            </Modal>

            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="Series Manager"
                    links={[
                        { name: 'Dashboard', href: "/dashboard/app" },
                        { name: 'Football Series Manager' }
                    ]}
                />

                <Card>
                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <div className='search-filter-block'>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Select Team</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        onChange={({ target }) => handlestateFilterHandler(target.value)}
                                        id="demo-simple-select"
                                        style={{ width: "240px" }}
                                        label="Select Team"
                                        value={selectTeamName}
                                    >
                                        {filterManagerListData && filterManagerListData.data.detail.map((value, index) => {
                                            return (
                                                value.name ?
                                                    <MenuItem value={value.name} key={index}> {value.name} </MenuItem>
                                                    :
                                                    null
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                                {selectTeamName &&
                                    <div className='reset-filter'>
                                        <Button
                                            size="small"
                                            color="primary"
                                            className='btn'
                                            onClick={handleResetFilter}
                                        >
                                            Reset Filter
                                        </Button>
                                    </div>
                                }
                            </div>
                            <Table>
                                <UserListHead
                                    rowCount={teamManagerData && teamManagerData.data.total_count}
                                    headLabel={[
                                        { id: "c_no", label: "Sr no.", alignRight: false },
                                        { id: 'name', label: 'Team Name', alignRight: false },
                                        { id: 'short', label: 'Team Short Name', alignRight: false },
                                        { id: 'flag', label: 'Flag', alignRight: false },
                                        { id: 'action', label: 'Action', alignRight: true }
                                    ]}
                                />
                                <TableBody>
                                    {teamManagerData && teamManagerData.data.detail.map((value, index) => {
                                        return (
                                            <TableRow hover key={index}>
                                                <TableCell component="th" scope="row">
                                                    {page * rowsPerPage + (index + 1)}.
                                                </TableCell>
                                                <TableCell component="th" scope="row">{value.name ? value.name : "-"} </TableCell>
                                                <TableCell component="th" scope="row">{value.short_code ? value.short_code : "-"}</TableCell>
                                                <TableCell component="th" scope="row">
                                                    {value.logo_path &&
                                                        <div className='small-flag'>
                                                            <img src={value.logo_path} alt={value.name} className="img-fluid" />
                                                        </div>
                                                    }
                                                </TableCell>
                                                <TableCell component="th" scope="row" align='right'>
                                                    <Button
                                                        size="small"
                                                        color="primary"
                                                        onClick={() => handleEdit(value)}
                                                    >
                                                        <BorderColorOutlined />
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Scrollbar>

                    <TablePagination
                        rowsPerPageOptions={[25, 50, 100, 150, 200]}
                        component="div"
                        count={teamManagerData && teamManagerData.data.total_count}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Card>
            </Container>
        </Page>
    );
}
